import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Plans } from "@/components/site/Plans";
import { QuickPlans } from "@/components/site/QuickPlans";
import { Differentials } from "@/components/site/Differentials";
import { Products } from "@/components/site/Products";
import { PromiseSection, Footer } from "@/components/site/Footer";
import { WhatsFab } from "@/components/site/WhatsFab";

export default function Landing() {
  useLenis();
  return (
    <main data-testid="landing-page" className="bg-[#07080f] text-white overflow-x-clip">
      <Nav />
      <Hero />
      <QuickPlans />
      <Marquee />
      <Plans />
      <Differentials />
      <Products />
      <PromiseSection />
      <Footer />
      <WhatsFab />
    </main>
  );
}
